module.exports = __webpack_public_path__ + "img/notask.4e9211f5.svg";